module.exports = __webpack_public_path__ + "static/img/6300_phase_function_Paper_PointsHejduk_Prediction.894d0a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6300_phase_function_Paper_PointsHejduk_Prediction.png
// module id = F4yN
// module chunks = 0